<template>
  <workspace-participants-management
    :workspace-id="workspaceId"
    participant-type="reviewer"
  />
</template>

<script setup lang="ts">
  import WorkspaceParticipantsManagement from '../WorkspaceParticipantsManagement/WorkspaceParticipantsManagement.vue';

  defineProps<{
    workspaceId: string;
  }>();
</script>
